import {CodebookModel} from '../models/codebook.model';

export class DocumentTypeCodebook {
    static allTypes:CodebookModel[] = [
        {
            id:1,
            name:'DocumentType-jubilejná fir. publ.'
        } ,{
            id:2,
            name:'DocumentType-konferenčný zborník'
        } ,{
            id:3,
            name:'DocumentType-leporelo, skladačka'
        } ,{
            id:4,
            name:'DocumentType-monografia'
        } ,{
            id:5,
            name:'DocumentType-skriptá'
        } ,{
            id:6,
            name:'DocumentType-učebné texty'
        } ,{
            id:7,
            name:'DocumentType-vysokoškolská učebnica'
        } ,{
            id:8,
            name:'DocumentType-zborník'
        } ,{
            id:9,
            name:'DocumentType-zborník vedeckých prác'
        } ,{
            id:11,
            name:'DocumentType-atlas'
        } ,{
            id:18,
            name:'DocumentType-mapa'
        } ,{
            id:20,
            name:'DocumentType-oficiálna publikácia'
        } ,{
            id:21,
            name:'DocumentType-slepecká tlač'
        } ,{
            id:22,
            name:'DocumentType-spevník'
        } ,{
            id:23,
            name:'DocumentType-študijné programy'
        } ,{
            id:24,
            name:'DocumentType-výročná správa'
        } ,{
            id:25,
            name:'DocumentType-zmiešané média'
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/codebook/document-type-codebook.ts